import { Component, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../../data.service';

@Component({
  selector: 'lc-account-create',
  templateUrl: './account-create.component.html',
  styleUrls: ['./account-create.component.scss']
})
export class AccountCreateComponent implements OnChanges {

  @Input() mode: string;

  // user: any = {};
  user_passwd: string;
  user_passwd2: string;
  passwords_equal: boolean;
  user_code: string;

  // after register
  signup_error: boolean = false;
  register_failed_email_exists: boolean;
  function_options: any[];

    constructor(private router: Router, private route: ActivatedRoute, public dataService: DataService) { }

    ngOnChanges(changes) {
      if( !this.dataService.subuser_info ){
        this.dataService.subuser_info = {};
      }
    }

    ngOnInit(){
      this.ngOnChanges({});
      if( !!this.dataService.signup_form && !!this.dataService.signup_form.questions ){
        for( const q of this.dataService.signup_form.questions ){
          if( q.field == 'function' ){
            this.function_options= q.options;
            break;
          }
        }
      }
    }

    isNumber(val): boolean { return typeof val === 'number'; }
    isString(val): boolean { return typeof val === 'string'; }

    scrollTop(){
      setTimeout(function(){
        window.scrollTo(0, 1);
      }, 0);
    }

    cancelRegistration(){
      this.scrollTop();
      try{ window['track_event']({name: "interaction", description: "cancel_account_create"}) }catch(e){}
      this.router.navigate(['/shop']);
    }

    updateOrSignupUser() {
      if(this.mode === 'edit') this.updateUser();
      if(this.mode === 'create') this.signup();
    }

    signup(){
      let passwords_equal = this.new_passwordCheck();
      if(passwords_equal) {
          this.dataService.subuser_info.parent = this.dataService.user_info.id;
          this.dataService.subuser_info.password = this.user_passwd;
          // email must be lower case !
          let email_lw = this.dataService.subuser_info.email.toLowerCase();
          this.dataService.subuser_info.email = email_lw;

          this.dataService.create_user(this.dataService.subuser_info).subscribe(
            (details) => {
              // console.debug(details);
              try{ window['track_event']({name: "interaction", description: "account_create_success"}) }catch(e){}
              this.dataService.user_info = undefined; // reset this so we go back to the loginpage
              this.user_code = undefined;
              this.dataService.presentMessage('We sturen u een mail ter verificatie van uw e-mailadres.', 'success');
              this.dataService.presentMessage('Activeer uw account via de mail die u heeft gehad en log hierna in.', '', 0);
              
              this.dataService.user_info = {};
              this.scrollTop();
              this.router.navigate(['/shop']);
              // NOTE: the new user is logged in  (but not verified)
              },
              (error) => {
                let err = error.json();
                // console.error(err);
                try{ window['track_event']({name: "interaction", description: "account_create_failed"}) }catch(e){}
                this.signup_error = true;
                if(err.type == 'Conflict') {
                  this.register_failed_email_exists = true;
                  this.dataService.presentMessage('Account bestaat al, probeer in te loggen of vraag een nieuw wachtwoord aan', 'error', 0);
                }
                else {
                  this.dataService.presentMessage('Registratie is helaas mislukt', 'error', 0);
                }
              },
              () => {

              }
              );
      }
      else {
        console.debug('passwords not the same');
      }
    }

    updateUser(){
      this.dataService.update_user(this.dataService.subuser_info).subscribe(
        (details) => {
          console.debug(details);
          this.dataService.presentMessage('U heeft uw accountgegevens sucessvol bijgewerkt.', 'success');
          // NOTE: the new user is logged in  (but not verified)
          },
          (error) => {
            console.warn(error);
            this.dataService.presentMessage('Er iets fout gegaan tijdens het aanpassen van uw accountgegevens', 'error', 0);
         }
       );
    }

    new_passwordCheck(){
      if (this.user_passwd === this.user_passwd2) {
        this.passwords_equal = true;
      }
      else{
        this.passwords_equal = false;
      }
      return this.passwords_equal;
    }

    togglePasswordReset() {
      this.router.navigate(['']);
    }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/account-management/account-create/account-create.component.ts